import { render, staticRenderFns } from "./sk-checkbox-wap.vue?vue&type=template&id=66982b8c&scoped=true&"
import script from "./sk-checkbox-wap.vue?vue&type=script&lang=js&"
export * from "./sk-checkbox-wap.vue?vue&type=script&lang=js&"
import style0 from "./sk-checkbox-wap.vue?vue&type=style&index=0&id=66982b8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66982b8c",
  null
  
)

export default component.exports